export enum StatusBudget {
  PRE_BUDGET = "PRE_BUDGET",
  DRAFT = "DRAFT",
  SENT = "SENT",
  DENIED = "DENIED",
}
